import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { Instituicao, Subtitulo, Line, Titulo, EnhancedTable } from '@monorepo-web/components-library';
import {
  setIF,
  fetchFluxoCaixa,
  sendAnalyticsData,
  useAppDispatch,
  useAppSelector,
  useFetchAPIs,
  formatRowsFluxoCaixa,
  getColumnsFluxoCaixa,
} from '@monorepo-web/logic-extrato';

import LoadingModal from '../LoadingModal';

import HeaderWrapper from '../../MainLayout/HeaderWrapper';
import { TabelaFluxoAtivos } from '@monorepo-web/templates';
interface Props {
  ignoraMesAtual?: boolean | null;
  dispatchPDF?: boolean;
}

export default function FluxoCaixa({ ignoraMesAtual, dispatchPDF }: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const uselocation = useLocation();

  const [
    obj_datas,
    fluxo_de_ativos_caixa,
    isLoaded,
    loading,
    isLoadedLista,
    loadingLista,
    listaIFs,
    IF,
    loadedCarteiraList,
    isLoadingMinimized,
    params,
    preferenceCustomizacao,
  ] = useAppSelector((state) => [
    state.fluxoCaixa.obj_datas,
    state.fluxoCaixa.fluxo_de_ativos_caixa,
    state.fluxoCaixa.isLoaded,
    state.fluxoCaixa.loading,
    state.fluxoCaixa.isLoadedLista,
    state.fluxoCaixa.loadingLista,
    state.fluxoCaixa.listaIFs,
    state.fluxoCaixa.IF,
    state.preference.loadedCarteiraList,
    state.loadMinimized.isLoadingMinimized,
    state.preference.params,
    state.preference.preferenceStyle.customizacao,
  ]);

  useEffect(() => {
    if (!dispatchPDF) document.title = `${(window as any).env.REACT_APP_TABNAME} - Fluxo de Caixa`;
  }, []);

  useEffect(() => {
    if (isLoaded && !dispatchPDF) dispatch(sendAnalyticsData(location.href));
  }, [params, isLoaded]);

  useFetchAPIs(isLoadedLista, loadingLista, dispatchPDF);

  useEffect(() => {
    if (!loading && fluxo_de_ativos_caixa?.length === 0 && IF !== '') {
      dispatch(fetchFluxoCaixa());
    }
  }, [isLoaded, IF]);

  /**
   * Carregar o IF quando a página for recarregada
   */
  useEffect(() => {
    if (isLoadedLista && IF === '') {
      // se não tiver o isLoadedLista, o componente select da warning out-of-range
      const IF_history = uselocation?.state?.IF ?? '';
      if (IF_history) {
        dispatch(setIF(IF_history));
      }
    }
  }, [isLoadedLista]);

  const handleSelect = (value: string) => {
    const url = `?carteira=${params.carteira}&periodo=${params.periodo}`;
    navigate(url, { state: { IF: value } }); // adiciona o IF selecionado no state do History router
    dispatch(setIF(value));
  };

  const rowsFluxoCaixa = isLoaded ? formatRowsFluxoCaixa(fluxo_de_ativos_caixa) : null;
  const columnsFluxoCaixa = getColumnsFluxoCaixa();

  return (
    <>
      <Grid>
        <HeaderWrapper
          title="Fluxo de Caixa"
          containerAux
          periodo
          instProps={{
            options: listaIFs,
            initialOption: IF,
            loadingOptions: loadingLista,
            handleSelect,
          }}
          obj_datas={obj_datas}
          subtitle_date
        />
        <Line />
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {IF !== '' ? (
            isLoaded ? (
              isLoaded && fluxo_de_ativos_caixa && fluxo_de_ativos_caixa.length > 1 ? (
                <>
                  <TabelaFluxoAtivos rows={rowsFluxoCaixa} layout='fluxo_caixa'/>
                </>
              ) : !loading ? (
                <span>Nenhuma movimentação encontrada neste período</span>
              ) : null
            ) : null
          ) : null}

          {isLoadedLista && listaIFs.length === 0 && IF === '' ? (
            <Subtitulo>
              Nenhuma instituição financeira foi encontrada nesta carteira, entre em contato com seu
              gestor{' '}
            </Subtitulo>
          ) : null}

          {isLoadedLista && listaIFs.length !== 0 && IF === '' ? (
            <div>
              <Titulo>Selecione uma instituição</Titulo>
              <Instituicao
                options={listaIFs}
                initialOption={IF}
                loadingOptions={loadingLista}
                disabled={isLoadingMinimized}
                handleSelect={handleSelect}
                floatLeft={true}
              />
            </div>
          ) : null}
        </Grid>
      </Grid>
      <LoadingModal loading={(IF !== '' && !isLoaded) || loading} showMinimizar={false} />
    </>
  );
}
